// extracted by mini-css-extract-plugin
export default {"logs":"RoleLogs_logs__c1Iog"};